<template>
	<div class="base-layout">
		<TopHeader />
		<NavigationBar />
		<router-view />
		<!-- 这里显示路由对应的内容 -->
     <bottomView />
	</div>
</template>

<script lang="ts" setup>
import TopHeader from '@/components/Header.vue';
import NavigationBar from '@/components/MyNav.vue';
import bottomView from '@/components/bottomView.vue';
</script>
